// extracted by mini-css-extract-plugin
export default {"commentList":"KGNDd","separator":"_2I1Cb"};